module.exports = __webpack_public_path__ + "static/img/oven.9fc21c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/oven.png
// module id = K5XQ
// module chunks = 1